import { CSSTransition } from 'react-transition-group';
import ITransitionProps from './TransitionProps';

const Transition = ({ transitionName, isOpen, speedIn, speedOut, children }: ITransitionProps) => {
  return (
    <CSSTransition
      in={isOpen}
      classNames={transitionName}
      timeout={{ enter: speedIn, exit: speedOut }}
      unmountOnExit={true}
    >
      <>{children}</>
    </CSSTransition>
  );
};

Transition.defaultProps = {
  speedIn: 500,
  speedOut: 250,
};

export default Transition;
